import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// Pre-rendered HTML (see scripts/prerender.mjs) is hydrated; a blank page is rendered normally.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, tree, {
    onRecoverableError: () => {
      /* consent state / language may differ from the snapshot – React re-renders the tree */
    },
  });
} else {
  ReactDOM.createRoot(container).render(tree);
}
